export const environment = {
  apiIsMocked: true,
  backendRootUrl: 'http://localhost:3000',
  backendWebsocketUrl: 'ws://localhost:3000',
};
